import { render, staticRenderFns } from "./KeyPerformanceIndicatorsPane.vue?vue&type=template&id=28dad408&"
import script from "./KeyPerformanceIndicatorsPane.vue?vue&type=script&lang=ts&"
export * from "./KeyPerformanceIndicatorsPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28dad408')) {
      api.createRecord('28dad408', component.options)
    } else {
      api.reload('28dad408', component.options)
    }
    module.hot.accept("./KeyPerformanceIndicatorsPane.vue?vue&type=template&id=28dad408&", function () {
      api.rerender('28dad408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/KeyPerformanceIndicatorsPane.vue"
export default component.exports